export default function constructUrl(baseUrl: string, path?: string): string {
  if (baseUrl === "" || !path || path === "") return "";
  if (baseUrl === "__DOLTHUB_BLOG_REWRITE_SITE_URL__") {
    return `${baseUrl}${path.replace("/blog", "")}`;
  }
  return `${baseUrl.replace("/blog", "")}${path}`;
}
